// extracted by mini-css-extract-plugin
export var alignLeft = "s_pL d_bF";
export var alignCenter = "s_bN d_bC";
export var alignRight = "s_pM d_bG";
export var embedInnerWrapperDesign1 = "s_r0 d_bL";
export var embed = "s_r1 d_b0";
export var titleMargin = "s_qY d_cv d_dv";
export var subtitleMargin = "s_r2 d_cr d_dv";
export var paragraphMargin = "s_r3 d_cv d_dv";